/**
 * API v1 for FLEXI web portal
 * A sample description of FLEXI API version 1 for web portal.
 *
 * OpenAPI spec version: 1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type ContactPersonType = 'Undefined' | 'ContactPerson' | 'Accounter' | 'PropertyManagerContact' | 'RequirementConsultant' | 'PersonAuthorizedToSign';

export const ContactPersonType = {
    Undefined: 'Undefined' as ContactPersonType,
    ContactPerson: 'ContactPerson' as ContactPersonType,
    Accounter: 'Accounter' as ContactPersonType,
    PropertyManagerContact: 'PropertyManagerContact' as ContactPersonType,
    RequirementConsultant: 'RequirementConsultant' as ContactPersonType,
    PersonAuthorizedToSign: 'PersonAuthorizedToSign' as ContactPersonType
};